export default {"src":"/_next/static/media/aura-profile.14e9e7a7.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};